import axios from 'axios'

/**
 * Statut HTTP de la réponse Axios si présent.
 * @param {unknown} error Erreur levée par Axios ou une autre source (réseau, parsing, etc.).
 * @returns {number | undefined} Code statut HTTP (ex. `404`, `500`) ou `undefined` si absent / non-Axios.
 */
export function getAxiosResponseStatus(error: unknown): number | undefined {
  return axios.isAxiosError(error) ? error.response?.status : undefined
}
